import { LH_API_BASE_URL, LH_CUSTOMER_API_BASE_URL } from "@/config";
import axios from "axios";
import { showErrorModal } from "../http/utils";

const shopTokenMapping = new Map<number, string>();

const lhAxios = axios.create({
    baseURL: LH_API_BASE_URL,
    timeout: 30000,
});

const lhCustomerAxios = axios.create({
    baseURL: LH_CUSTOMER_API_BASE_URL,
    timeout: 30000,
});

export function switchLhShopToken(shopId: number, token: string) {
    shopTokenMapping.set(shopId, token);

    lhAxios.defaults.headers = {
        token,
        from: "fahuoyi",
        platform: "TAOBAO",
    };
}

const onFulfilled = (response) => {
    if (response.data?.success === true) {
        return response?.data?.data;
    }

    const errorCode = response?.data?.errorCode;

    if (errorCode === "403" || errorCode === "401") {
        showErrorModal("太久没操作了", "请刷新页面试试");

        return Promise.reject(new Error("来火定制授权过期"));
    }

    const errorMessage = response?.data?.errorMessage;

    showErrorModal("错误信息", errorMessage);

    return Promise.reject(new Error(errorMessage));
};

const onRejected = (error) => {
    showErrorModal("请求失败", `链接：${error?.config?.url}，发生错误：${error.message}`);

    return Promise.reject(error);
};

lhAxios.interceptors.response.use(onFulfilled, onRejected);

lhCustomerAxios.interceptors.response.use(onFulfilled, onRejected);

const post = <T,>(urlPath: any, data?: any, config = {}): Promise<T> => lhAxios.post(urlPath, data, config);

const get = <T,>(urlPath: any, params?: any): Promise<T> => lhAxios.get(urlPath, { params });

const lhServerClient = { post, get };

const lhCustomerClientPost = <T,>(urlPath: any, data?: any, config = {}): Promise<T> =>
    lhCustomerAxios.post(urlPath, data, config);

const lhCustomerClientGet = <T,>(urlPath: any, params?: any): Promise<T> => lhCustomerAxios.get(urlPath, { params });

export const lhCustomerClient = {
    get: lhCustomerClientGet,
    post: lhCustomerClientPost,
};

export default lhServerClient;
